/*
 * @Author: your name
 * @Date: 2021-07-20 14:18:36
 * @LastEditTime: 2021-07-23 09:41:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \admine:\LBB\front_end_nest_app_project\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
const e404 = () => import('@/pages/404.vue')
const BusinessActivities = () => import("@/pages/businessActivities");
const seeBusinessLicense = () => import("@/pages/seeBusinessLicense");
const storeInfo = () => import("@/pages/seeBusinessLicense/storeInfo.vue");



Vue.use(Router)

let router = new Router({
	// mode: 'hash',
	mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
	routes: [
		{
			path: '*',
			redirect: "/404"
		},
		{
			path: '/404',
			component: e404
		},
		// {
		// 	path: '/',
		// 	redirect: "/businessActivities"
		// },
		{
			path: '/businessActivities',
			component: BusinessActivities,
			name: 'businessActivities',
			meta: {
				title: '商家活动',
			},
		},
		{
			path: '/seeBusinessLicense',
			component: seeBusinessLicense,
			name: 'seeBusinessLicense',
			meta: {
				title: '证照信息',
			},
		}, {
			path: '/storeInfo',
			component: storeInfo,
			name: 'storeInfo',
			meta: {
				title: '证照信息',
			},
		}
	]
});
router.beforeEach((to, from, next) => {
	// console.log(router, to, from)
	// if (to.path == '/') {
	// 	next({ path: '/businessActivities', replace: true })
	// } else
	// 	if (router.options.routes.filter(item => {
	// 		return item.path == to.path
	// 	}).length) {
	next()
	// 	} else {
	// 		next({ path: '/404', replace: true })
	// 	}

})
router.afterEach((to, from) => {
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js